import { Box, Paper, Typography } from "@mui/material";
import { EmailOutlined, InfoOutlined, PhoneOutlined, PlaceOutlined } from "@mui/icons-material";
import { Button, PageHeader } from "@components/ui_v2";

// TODO: contacto del prototipo (`WW_NoPerfil`); confirmar el de WuWei.
const CONTACTO = { telefono: "55 9104 4964", correo: "contacto@lendia.mx" };

interface Props {
  /** "Me equivoqué en mi domicilio": regresa al formulario para corregirlo. */
  onCorregirDomicilio: () => void;
  onSalir: () => void;
}

/**
 * `WW_NoPerfil` del diseño de WuWei: el domicilio de "Tus datos" está fuera de la zona de cobertura. Se muestra en
 * la misma pantalla, en lugar del formulario, y no se avanza de status.
 */
export const SinCoberturaWuWei = ({ onCorregirDomicilio, onSalir }: Props) => (
  <Box>
    <PageHeader
      eyebrow="Resultado"
      title="¡Gracias por tu interés!"
      subtitle="Por el momento no podemos ofrecerte el arrendamiento de tu auto."
    />

    <Paper variant="lendia_paper" sx={{ textAlign: "center" }}>
      <Box
        sx={{
          width: 56,
          height: 56,
          mx: "auto",
          mb: 2,
          borderRadius: "50%",
          display: "grid",
          placeItems: "center",
          bgcolor: "primary.base",
          color: "primary.dark",
        }}
      >
        <InfoOutlined />
      </Box>
      <Typography variant="h4" sx={{ fontWeight: 600, color: "primary.dark", mb: 1 }}>
        Te avisaremos cuando cubramos tu zona
      </Typography>
      <Typography variant="body2" sx={{ color: "tokens.textSecondary", maxWidth: 480, mx: "auto" }}>
        Tu domicilio está fuera de nuestra zona de operación, por lo que por ahora no podemos ofrecerte una unidad.
        Guardaremos tus datos y te contactaremos en cuanto operemos en tu zona.
      </Typography>

      <Box
        sx={{
          mt: 3,
          p: 2,
          display: "flex",
          gap: 1.5,
          textAlign: "left",
          borderRadius: "10px",
          border: "1px solid",
          borderColor: "divider",
        }}
      >
        <PlaceOutlined sx={{ color: "primary.dark", mt: "2px" }} />
        <Box>
          <Typography variant="body2" sx={{ fontWeight: 600, color: "primary.dark" }}>
            Zona de cobertura
          </Typography>
          <Typography variant="body2" sx={{ color: "tokens.textSecondary" }}>
            Por ahora solo operamos en el área metropolitana del Valle de México. Necesitamos que tu domicilio esté
            dentro de nuestra zona de operación.
          </Typography>
        </Box>
      </Box>
    </Paper>

    <Paper variant="lendia_paper" sx={{ mt: 2, bgcolor: "tokens.surface2" }}>
      <Typography variant="body1" sx={{ fontWeight: 600, color: "primary.dark" }}>
        ¿Tienes dudas?
      </Typography>
      <Typography variant="body2" sx={{ color: "tokens.textSecondary", mb: 1.5 }}>
        Contáctanos y te ayudamos a entender los siguientes pasos.
      </Typography>
      <Box sx={{ display: "flex", flexWrap: "wrap", gap: { xs: 1, sm: 3 } }}>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <PhoneOutlined fontSize="small" sx={{ color: "primary.dark" }} />
          <Typography variant="body2" sx={{ color: "primary.dark" }}>
            {CONTACTO.telefono}
          </Typography>
        </Box>
        <Box sx={{ display: "flex", alignItems: "center", gap: 1 }}>
          <EmailOutlined fontSize="small" sx={{ color: "primary.dark" }} />
          <Typography variant="body2" sx={{ color: "primary.dark" }}>
            {CONTACTO.correo}
          </Typography>
        </Box>
      </Box>
    </Paper>

    <Box sx={{ display: "flex", justifyContent: "flex-end", flexWrap: "wrap", gap: 1.5, mt: 4 }}>
      <Button tone="outline" onClick={onCorregirDomicilio} data-testid="tus-datos-corregir-domicilio-button">
        Me equivoqué en mi domicilio
      </Button>
      <Button tone="primary" onClick={onSalir} data-testid="tus-datos-salir-button">
        Salir
      </Button>
    </Box>
  </Box>
);
